class NavMenu extends HTMLElement {
  connectedCallback() {
    if(this.dataset.sticky === 'true' && !Shopify.designMode) {
      window.addEventListener('load', this.setupSticky.bind(this));
    }
  }

  setupSticky() {
    this.isSticky = false;
    this.homeContainer = this.parentElement;
    this.homeAnchor = this.nextElementSibling;

    ScrollTrigger.create({
      trigger: this.homeContainer,
      start: 'top top-=300',
      onEnter: this.stickToTop.bind(this),
      onLeaveBack: this.unstickFromTop.bind(this)
    });
  }

  stickToTop() {
    if(this.isSticky) {
      return;
    }
    this.isSticky = true;
    this.homeContainer.style.minHeight = `${this.offsetHeight}px`;

    const announcementBar = document.querySelector('announcement-bar');
    const offsetTop = (announcementBar && announcementBar.isSticky) ? announcementBar.offsetHeight : 0;

    this.glassEffect = this.querySelector('.glass-effect');
    if(this.glassEffect) {
      this.glassEffect.style.display = 'none';
    }

    this.style.backgroundColor = 'var(--color-scheme-background)';

    gsap.killTweensOf(this);
    gsap.set(this, {
      position: 'fixed',
      top: offsetTop,
      left: 0,
      zIndex: 4,
      yPercent: -100
    });
    document.body.prepend(this);
    gsap.to(this, {yPercent: 0, duration: 0.4});
  }

  unstickFromTop() {
    if(!this.isSticky) {
      return;
    }
    this.isSticky = false;
    gsap.killTweensOf(this);
    gsap.to(this, {
      yPercent: -100,
      duration: 0.4,
      onComplete: () => {
        this.homeContainer.insertBefore(this, this.homeAnchor);
        gsap.set(this, {clearProps: 'position,top,left,zIndex,yPercent'});
        this.style.removeProperty('background-color');
        this.homeContainer.style.minHeight = '';

        if(this.glassEffect) {
          this.glassEffect.style.display = '';
          this.glassEffect = null;
        }
      }
    });
  }
}

customElements.define('nav-menu', NavMenu);
